import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const viteEnv = import.meta as ImportMeta & { env?: { PROD?: boolean } };

if ("serviceWorker" in navigator && viteEnv.env?.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("Protium Monitoring service worker registration failed", error);
    });
  });
}
